import { defineMessages } from 'react-intl';
export const scope = 'utils.country';

export default defineMessages({
  Deutschland: {
    id: `${scope}.Deutschland`,
    defaultMessage: 'Nemačka',
  },
  Srbija: {
    id: `${scope}.Srbija`,
    defaultMessage: 'Srbija',
  },
  Hrvatska: {
    id: `${scope}.Hrvatska`,
    defaultMessage: 'Hrvatska',
  },
  CrnaGora: {
    id: `${scope}.CrnaGora`,
    defaultMessage: 'Crna Gora',
  },
  BosnaiHercegovina: {
    id: `${scope}.BosnaiHercegovina`,
    defaultMessage: 'Bosna i Hercegovina',
  },
  Nederland: {
    id: `${scope}.Nederland`,
    defaultMessage: 'Holandija',
  },
  Eire: {
    id: `${scope}.Eire`,
    defaultMessage: 'Irska',
  },
  Norge: {
    id: `${scope}.Norge`,
    defaultMessage: 'Norveška',
  },
  France: {
    id: `${scope}.France`,
    defaultMessage: 'Francuska',
  },

  NorthMacedonia: {
    id: `${scope}.North Macedonia`,
    defaultMessage: 'Severna Makedonija',
  },
  Slovensko: {
    id: `${scope}.Slovensko`,
    defaultMessage: 'Slovačka',
  },
  Österreich: {
    id: `${scope}.Österreich`,
    defaultMessage: 'Austrija',
  },
  CeskaRepublika: {
    id: `${scope}.CeskaRepublika`,
    defaultMessage: 'Češka republika',
  },
  Danmark: {
    id: `${scope}.Danmark`,
    defaultMessage: 'Danska',
  },
  Slovenija: {
    id: `${scope}.Slovenija`,
    defaultMessage: 'Slovenija',
  },
  India: {
    id: `${scope}.India`,
    defaultMessage: 'Indija',
  },
  دولةالإماراتالعربيةالمتحدة: {
    id: `${scope}.دولةالإماراتالعربيةالمتحدة`,
    defaultMessage: 'UAE',
  },
  العربيةالسعودية: {
    id: `${scope}.العربيةالسعودية`,
    defaultMessage: 'Saudijska Arabija',
  },
  عمان: {
    id: `${scope}.عمان`,
    defaultMessage: 'Oman',
  },
});
